import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const chatbotMessagesList = async ({ accessToken, username }) => {
  try {
    const response = await axiosInstance.get("user/@me/chatrooms", {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = `/${username}`;
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};
export const chatbotMessages = async ({ accessToken, roomId, username }) => {
  try {
    const response = await axiosInstance.get(
      `/business/chats/${roomId}/messages`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      if (serverError) toast.error(serverError);
      else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      /*
      if (status === 403) {
        console.warn(
          "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
        );
        window.location.href = `/${username}`;
        return;
      }

      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

// export const chatbotSendMessage = async ({
//   accessToken,
//   message,
//   roomId,
//   username,
// }) => {
//   try {
//     const response = await axiosInstance.post(
//       `/business/chats/send`,
//       { roomId, message },
//       {
//         headers: {
//           Authorization: `Bearer ${accessToken}`,
//         },
//       withCredentials: true
//       }
//     );
//     return response.data;
//   } catch (error) {
//     if (error.response) {
//       const status = error.response.status;
//       if (status === 403) {
//         console.warn(
//           "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
//         );
//         window.location.href = `/${username}`;
//         return;
//       }

//       throw {
//         statusCode: status,
//         message:
//           error.response.data?.message || "خطای ناشناخته هنگام دریافت گفتگوها",
//       };
//     } else {
//       throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
//     }
//   }
// };
export const chatbotSendMessage = async ({
  accessToken,
  message,
  roomId,
  username,
}) => {
  try {
    const response = await axiosInstance.post(
      "/business/chats/send",
      { roomId, message, roomId },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      // if (serverError) toast.error(serverError);
      // else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      if (error.status == 402) {
        throw {
          statusCode: status,
          message: serverError,
          redirect: `/bot/wallet/${username}`,
        };
      } else {
        throw {
          statusCode: status,
          message: serverError,
          redirect: `/bot/chatbox/${username}`,
        };
      }
      /*
      if (status === 403) {
        if (
          serverError === "Subscription has been expired or run out of tokens."
        ) {
          throw {
            statusCode: 403,
            message: serverError,
            redirect: `/bot/dashboard/${username}`,
          };
        } else if (
          serverError ===
          "You reached your maximum token usage, please change your message."
        ) {
          throw {
            statusCode: 403,
            message: "پیام شما بیش از حد مجاز است.",
          };
        } else if (
          serverError ===
          "Business tokens are used. You can reach out to the business owner for more information."
        ) {
          throw {
            statusCode: 403,
            message: "امکان چت با ربات وجود ندارد. لطفا بعدا تلاش کنید.",
            redirect: `/bot/dashboard/${username}`,
          };
        } else {
          throw {
            statusCode: 403,
            message: "کاربر به صفحه ورود هدایت می‌شود.",
            redirect: `/${username}`,
          };
        }
      } else if (status === 429) {
        if (serverError === "You reached your daily messages.") {
          throw {
            statusCode: 429,
            message: "تعداد پیام‌های روزانه‌ی شما به اتمام رسیده است.",
            redirect: `/bot/dashboard/${username}`,
          };
        } else if (serverError.startsWith("Your message is more than")) {
          throw {
            statusCode: 429,
            message: "طول پیام شما بیش از حد مجاز است.",
          };
        }
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message || "خطای ناشناخته هنگام ارسال پیام",
      };
      */
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const createChatbotRoom = async ({ accessToken, username }) => {
  try {
    const response = await axiosInstance.post(
      `/business/@${username}/create`,
      {},
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;
      //if (serverError) toast.error(serverError);
      //else toast.error("مشکل شبکه یا عدم دسترسی به سرور");
      throw {
        statusCode: status,
        message: serverError,
        redirect: `/bot/chatbox/${username}`,
        overLimit: true,
      };
      // if (status === 403) {
      //   if (serverError === "Business Bot has reached it maximum users, you can contact the owner about it.") {
      //     toast.error("تعداد کاربران مجاز بات  به حد نصاب رسیده است. شما امکان چت با بات را ندارید.");
      //     setTimeout(() => {
      //       window.location.href = `/${username}`;
      //     }, 3000);
      //   } else {
      //     console.warn("خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود.");
      //     window.location.href = `/${username}`;
      //     return;
      //   }
      // }
      /*
      if (status === 403) {
        if (
          serverError ===
          "Business Bot has reached it maximum users, you can contact the owner about it."
        ) {
          throw {
            statusCode: 403,
            message:
              "تعداد کاربران مجاز بات  به حد نصاب رسیده است. شما امکان چت با بات را ندارید.",
            overLimit: true,
          };
        } else {
          throw {
            statusCode: 403,
            message: "دسترسی غیرمجاز. شما اجازه ورود ندارید.",
          };
        }
      }
      throw {
        statusCode: status,
        message:
          error.response.data?.message ||
          "خطای ناشناخته هنگام ایجاد گفتگوی جدید",
      };*/
    } else {
      throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
    }
  }
};

export const deleteChatbotRoom = async ({
  accessToken,
  roomId,
}) => {
  try {
    const response = await axiosInstance.delete(
      `/user/@me/chatrooms/${roomId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        withCredentials: true,
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      const serverError = error.response.data?.error;

      throw {
        statusCode: status,
        message: serverError || "خطا هنگام حذف گفتگو",
      };
    }

    throw {
      statusCode: 500,
      message: "مشکل شبکه یا عدم دسترسی به سرور",
    };
  }
};
